'use client';

import React from "react"
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  // Detect theme from system preference
  const theme = typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg rounded-md",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary-600 group-[.toast]:text-white group-[.toast]:hover:bg-primary-700",
          cancelButton:
            "group-[.toast]:bg-secondary group-[.toast]:text-secondary-foreground",
        },
      }}
      duration={4000}
      position="top-right"
      {...props}
    />
  )
}

// Helper functions for standardized toasts
export const toastSuccess = (message: string, description?: string) => {
  return toast.success(message, {
    description,
    duration: 4000,
    className: 'bg-primary-50 border-primary-200 text-primary-900 dark:bg-primary-900/20 dark:border-primary-800 dark:text-primary-100',
  });
};

export const toastError = (message: string, description?: string) => {
  return toast.error(message, {
    description,
    duration: 4000,
    className: 'bg-destructive/10 border-destructive/50 text-destructive dark:bg-destructive/20 dark:border-destructive dark:text-destructive',
  });
};

export { Toaster, toast }
